export const TestIds = {
  overflow: 'responsive-container-overflow',
  content: 'responsive-container-content',
} as const;
